class Contact {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("contact", () => ({
                    message: null,

                    phone1: null,
                    phone2: null,
                    email1: null,
                    email2: null,

                    contactType: null,

                    contactLoading: false,

                    sendSuccess: false,
                    sendLoading: false,
                    sendError: null,

                    LOADING: 1,
                    ERROR: 2,

                    contacts(type) {
                        if (this.contactLoading) {
                            return;
                        }

                        this.contactType = type;
                        // if (window.CONFIG.connected) {
                        if (
                            this.phone1 ||
                            this.phone2 ||
                            this.email1 ||
                            this.email2
                        ) {
                            this.openDialogInfoContact();
                            return;
                        }

                        this.contactLoading = false;

                        window.useHttpApi
                            .get(`/v1/event/${this.date.eventId}/contact`)
                            .then(({ body }) => {
                                this.phone1 = body.phone1 ?? null;
                                this.phone2 = body.phone2 ?? null;
                                this.email1 = body.email1 ?? null;
                                this.email2 = body.email2 ?? null;
                                this.openDialogInfoContact();
                            })
                            .catch(() => {
                                window.useSnackbar.add({
                                    key: window.useSnackbar.ERROR,
                                    type: window.useSnackbar.TYPE_ERROR,
                                    message:
                                        "Nous avons rencontré une erreur. Veuillez réessayer ultérieurement.",
                                    close: true,
                                });
                            })
                            .finally(() => {
                                this.contactLoading = false;
                            });
                        // }
                    },

                    openDialogInfoContact() {
                        const dialog = document.querySelector(
                            `[x-ref='dialogInfoContact']`,
                        );

                        if (dialog && !dialog.open) {
                            dialog.showModal();
                        }
                    },
                    send(organiser, element) {
                        if (
                            element.ariaDisabled === "true" ||
                            this.sendSuccess
                        ) {
                            return;
                        }

                        this.sendLoading = true;
                        if (window.CONFIG.connected) {
                            window.useHttpApi
                                .post(`/v1/message`, {
                                    recipient: organiser,
                                    event: this.date.eventId,
                                    message: this.message,
                                })
                                .then(() => {
                                    this.sendSuccess = true;
                                    setTimeout(() => {
                                        this.closeDialog();
                                    }, 1000);
                                })
                                .catch(() => {
                                    this.sendError = true;
                                })
                                .finally(() => {
                                    this.sendLoading = false;
                                });
                        }
                    },
                    closeDialog(close = true) {
                        if (close) {
                            const dialog = document.querySelector(
                                `[x-ref='dialogContact']`,
                            );

                            if (dialog?.open) {
                                dialog.close();
                            }
                        }
                        this.message = null;
                        this.sendError = false;
                        this.sendLoading = false;
                        this.sendSuccess = false;
                    },
                }));
            },
            { once: true },
        );
    }
}

new Contact();
